import React, { ReactElement } from 'react';
import { css } from '@emotion/css';
import { Result } from 'antd';
import { WarningTwoTone } from '@ant-design/icons';
import { messageConfig } from 'config/appMessageConfig';

interface Props {
    style?: React.CSSProperties;
    errorStyle?: React.CSSProperties;
    msg?: string;
}

const errorClass = css`
    & .ant-result-icon {
        margin-bottom: 0px;
    }
    & .ant-result-title {
        line-height: 1;
    }
`;
const defaultMsg = messageConfig.errorMessages.default;

export default function ErrorBox({ style = {}, msg = defaultMsg, errorStyle }: Props): ReactElement {
    const errorMessageMapping = messageConfig.errorMessages[msg] || defaultMsg;

    return (
        <div className="flex flex-col " style={style}>
            {
                <Result
                    style={errorStyle}
                    className={`${errorClass} p-0`}
                    icon={<WarningTwoTone style={{ fontSize: '1.6rem' }} />}
                    title={<span className="text-xs">{errorMessageMapping}</span>}
                />
            }
        </div>
    );
}
